import { useState } from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { faStars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConvertExclusiveModal } from './ConvertExclusiveModal';
import { convertDollarsToCents, getPPCDetails } from './helpers';
import { Price } from './types';
import _ from 'lodash';

type ExclusiveCreatorToggleProps = {
  influencerId: number;
  canConvertToPPC: boolean;
  visibility: string;
  subscriptionMonthlyPrice: number | null;
  subscriptionAnnualPrice: number | null;
  refetch: () => void;
};

export const ExclusiveCreatorToggle = (props: ExclusiveCreatorToggleProps) => {
  const [ppcDetails, setPPCDetails] = useState(getPPCDetails(props));
  const [isCreatorExclusive, setCreatorExclusive] = useState<boolean>(
    props.visibility === 'exclusive',
  );
  const [showModal, setShowModal] = useState<boolean>(false);

  const onConvertSuccess = (price: Price) => {
    setCreatorExclusive(true);
    setPPCDetails(
      getPPCDetails({
        ...props,
        visibility: 'exclusive',
        subscriptionMonthlyPrice: price?.monthly
          ? convertDollarsToCents(price.monthly)
          : props.subscriptionMonthlyPrice,
        subscriptionAnnualPrice: price?.annual
          ? convertDollarsToCents(price.annual)
          : props.subscriptionAnnualPrice,
      }),
    );
    props.refetch();
  };

  return (
    <Box className="flex flex-col gap-2.5">
      <Box className="flex justify-between">
        <Box className="flex gap-[15px] justify-center items-center">
          <Box className="w-auto h-auto flex justify-center items-center">
            <FontAwesomeIcon
              icon={faStars}
              className="text-primary text-[24px]"
            />
          </Box>
          <Typography className="font-[700] m-0">
            Convert Platform Creator to PPC
          </Typography>
        </Box>
        <Switch
          checked={isCreatorExclusive}
          onChange={() => setShowModal(true)}
          disabled={!!ppcDetails}
          data-testid="ppcToggle"
        />
      </Box>
      {_.isEmpty(ppcDetails) ? null : (
        <>
          {ppcDetails?.map(({ label, type }) => (
            <Typography
              className={`text-[14px] m-0 ${
                type === 'action'
                  ? 'text-primary cursor-pointer'
                  : 'text-gray-4'
              }`}
              key={label}
              onClick={() => {
                type === 'action' && setShowModal(true);
              }}
            >
              {label}
            </Typography>
          ))}
        </>
      )}
      {showModal && (
        <ConvertExclusiveModal
          influencerId={props.influencerId}
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onConvertSuccess={onConvertSuccess}
          isExclusive={isCreatorExclusive}
          updatedPrice={
            props.subscriptionMonthlyPrice === null ? 'monthly' : 'annual'
          }
          subscriptionMonthlyPrice={props.subscriptionMonthlyPrice}
          subscriptionAnnualPrice={props.subscriptionAnnualPrice}
        />
      )}
    </Box>
  );
};
